exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".response-action__buttons{display:flex;justify-content:space-between;align-items:center;flex-flow:row wrap;gap:15px}h4{text-align:center}.delete-action__buttons{margin-top:20px;display:flex;align-items:center;justify-content:center;flex-flow:row wrap;gap:15px}.error p{background-color:#fadcdc;padding:10px;border-radius:5px;border:1px solid #c7c7c7;margin-bottom:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-701a5305","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/components/organisms/my-pages-sections/company/account/OrganismMyPageResponses.vue
// module id = 1394
// module chunks = 0